import client from "./internal/httpClient";

const businessApi = {}

businessApi.submit = function (data) {
    return client.post("/door-client/business/opportunity/add.php",data)
}

export default businessApi